import type { ReactNode } from "react";

/**
 * Radix Themes <Theme> is removed. This no-op wrapper preserves the element
 * tree shape (a single wrapping div like Radix rendered) and forwards only
 * DOM-safe props. Appearance/dark-mode is handled by ThemeProvider via the
 * `.dark` class on <html>; all Radix-specific props are intentionally ignored.
 */
export function Theme({
  children,
  className,
  style,
  id,
}: {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  [key: string]: unknown;
}) {
  return (
    <div className={className} style={style} id={id} data-theme-root="">
      {children}
    </div>
  );
}

export default Theme;
